import {
  siteNames,
  type SiteNamesMatchingClassification,
} from '@seek/melways-sites';

import type { EmployerSiteName } from 'src/types';

type EmployerANZSite =
  | SiteNamesMatchingClassification<{
      product: 'employer';
      country: 'au';
      consolidated: false;
    }>
  | SiteNamesMatchingClassification<{
      product: 'employer';
      country: 'nz';
      consolidated: false;
    }>;

export const isEmployerANZSite = (
  site: EmployerSiteName,
): site is EmployerANZSite =>
  site === siteNames.employer.seek.au || site === siteNames.employer.seek.nz;
